<template>
  <div class="method-switcher">
    <button class="button button-outline method" :class="methodId === activeMethod ? 'active ' + methodId : methodId" v-for="(method, methodId) in getRelevantMethods()" :key="methodId" @click="changeMethod" :value="methodId">
      <img :src="require('@/assets/' + method.img)" :title="method.name" />
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: mapState({
    methods: state => state.operators,
    availableMethods: state => Object.keys(state.operators)
      .filter(opId => {
        return state.operators[opId].currencies && state.operators[opId].currencies.indexOf(state.donation.currency) > -1 && state.operators[opId].published
      }),
    activeMethod: state => state.donation.method
  }),
  methods: {
    changeMethod (e) {
      const value = e.currentTarget.value
      this.$store.dispatch('changeMethod', value)
    },
    getRelevantMethods () {
      return Object.keys(this.methods).reduce((acc, methodId) => {
        if (this.availableMethods.indexOf(methodId) > -1) acc[methodId] = this.methods[methodId]
        return acc
      }, {})
    }
  }
}
</script>

<style>
  .oi-donate .method-switcher {
    display: flex;
    justify-content: center;
  }
  .oi-donate .method-switcher > .method {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 40px;
    padding: 10px;
    margin-bottom: 10px;
    opacity: 0.6;
    border-radius: 0px;
    background-color: #fff;
    border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
    border: 1px solid #d1d1d1;
    box-shadow: inset 0 1px 0 rgba(255,255,255,.2), 0 1px 2px rgba(0,0,0,.05);
    -webkit-filter: grayscale(1);
    filter: grayscale(1);
  }
  .oi-donate .method-switcher > .button.button-outline.method:hover,
  .oi-donate .method-switcher > .button.button-outline.method:focus {
    background-color: #fff;
    border: 1px solid #d1d1d1;
    border-color: #d1d1d1;
    box-shadow: inset 0 2px 4px rgba(0,0,0,.15), 0 1px 2px rgba(0,0,0,.05);
    -webkit-filter: grayscale(0);
    filter: none;
  }
  .oi-donate .method-switcher > .method > img {
    height: auto;
    width: auto;
    max-height: 15px;
  }
  .oi-donate .method-switcher > .method.active {
    box-shadow: inset 0 2px 4px rgba(0,0,0,.15), 0 1px 2px rgba(0,0,0,.05);
    opacity: 1;
    -webkit-filter: grayscale(0);
    filter: none;
    background-color: #fff;
  }
</style>
